<template>
  <div class="accordion" :class="{disabled: disabled}">
    <div :id="accordionId">
      <div
        v-for="(item, key) in items"
        :key="item.id || key"
        class="accordion-item"
      >
        <div
          v-b-toggle.stop="`${accordionId}-item_${item.id || key}`"
          class="accordion-header"
        >
          <span v-if="item.title">{{ item.title }}</span>

          <span v-if="!item.title" class="when-opened">{{
            item.titleOpened
          }}</span>
          <span v-if="!item.title" class="when-closed">{{
            item.titleClosed
          }}</span>
        </div>
        <BCollapse
          :id="`${accordionId}-item_${item.id || key}`"
          :accordion="id"
          :visible="item.visible"
          role="tabpanel"
          class="accordion-body"
        >
          <slot
            v-if="getSlot(`item_${item.id || key}`)"
            :name="`item_${item.id || key}`"
            :item="item"
          />

          <div v-else v-html="renderMarkdown(item.body)" />
        </BCollapse>
      </div>
    </div>
  </div>
</template>

<script>
import {BCollapse} from 'bootstrap-vue'
import {VBToggle} from 'bootstrap-vue'
import idMixin from 'bootstrap-vue/src/mixins/id'

const replaceMdLinks = (md) =>
  md.replace(/\[([^\]]+)\]\(([^)]+)\)/, '<a href="$2">$1</a>')

export default {
  name: 'accordian',
  components: {
    BCollapse,
  },

  mixins: [idMixin],

  directives: {
    BToggle: VBToggle,
  },

  props: {
    /**
     * Used as the base to generate any additional element IDs as needed.
     */
    id: {
      type: String,
      default: null,
    },

    /**
     * Array of items to render in the component
     */
    items: {
      type: Array,
      required: true,
    },

    /**
     * Accordion does not react on mouse events.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    accordionId() {
      return this.id || `accordion_${this.localId_}`
    },
  },

  methods: {
    getSlot(slotName) {
      return this.$scopedSlots[slotName] || this.$slots[slotName]
    },

    renderMarkdown(md) {
      return replaceMdLinks(md)
    },
  },
}
</script>

<style lang="scss">
// TODO: remove this and refactor the whole style file
@mixin icon-color($color) {
  content: escape-svg(
    url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none'><path fill='#{$color}' d='M12 11L8 6l-4 5z'/></svg>")
  );
}

.accordion {
  &.disabled {
    pointer-events: none;
    background-color: $gray-100;

    .accordion-header,
    .accordion-body {
      color: $gray-300;
    }

    .accordion-header {
      &:after {
        @include icon-color($gray-300);
      }
    }
  }

  &-item {
    font-size: $font-size-sm;
    display: flex;
    flex-direction: column;

    border-top: 1px solid $gray-200;
    border-bottom: 1px solid $gray-200;

    &:first-child {
      margin-bottom: -1px;
    }

    &:last-child {
      margin-top: -1px;
    }
  }

  &-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    padding: 0.9375rem 0;
    color: $gray-900;
    position: relative;

    &:hover {
      color: $cyan-700;

      &:after {
        @include icon-color($cyan-700);
      }
    }

    &:focus {
      outline: none;
      border: 2px solid $cyan-500;
      padding: subtract(0.9375rem, 2px) 0;
    }

    &:after {
      @include icon-color($gray-900);
      position: absolute;
      display: block;
      height: 16px;
      width: 16px;
      right: 0;
      top: 17px;
    }

    &.collapsed {
      &:after {
        transform: rotate(180deg);
      }
    }

    &.collapsed > .when-opened,
    &:not(.collapsed) > .when-closed {
      display: none;
    }

    span {
      flex-grow: 1;
    }
  }

  &-image {
    margin-right: 1rem;
  }

  &-body {
    color: $gray-800;
    margin-bottom: 1.5rem;
  }
}
</style>
